import * as React from "react";
import { SecurityType } from "../../../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { InvestmentSectorAllocationModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/InvestmentSectorAllocationModel";
import { ICombineTableConfig, ITableConfig, Table } from "../../../../../../../Shared/Table/Table";

interface ISectorAllocationTableProps extends React.Props<SectorAllocationTable> {
    data?: InvestmentSectorAllocationModel;
    isHeadAccount: boolean;
}

interface ISectorAllocationTableState {}

export class SectorAllocationTable extends React.Component<ISectorAllocationTableProps, ISectorAllocationTableState> {
    constructor(props: ISectorAllocationTableProps) {
        super(props);
    }

    public render(): JSX.Element {
        const { data } = this.props;
        const header = data.AssetSectorAllocations;
        let tableConfig: ITableConfig[] = [
            {
                title: "Investments",
                key: "InvestmentName",
                render: (data, row, index) => {
                    return row.SecurityType == SecurityType.Cash ||
                        row.SecurityType == SecurityType.Model ||
                        row.FinexDocumentUrl == "" ? (
                        data
                    ) : (
                        <a className="hyperlink" target="_blank" href={row.FinexDocumentUrl}>
                            {data}
                        </a>
                    );
                },
            },
        ];
        tableConfig = tableConfig.concat(
            header.map((ele) => {
                return {
                    title: ele.SectorName,
                    key: ele.SectorName,
                    thCssWrapper: "cell-right",
                    tdCssWrapper: "cell-right",
                };
            })
        );

        tableConfig.push({ title: "Total", key: "TotalValue", thCssWrapper: "cell-right", tdCssWrapper: "cell-right" });
        const content = data.InvestmentSectorAllocations.map((ele) => {
            const row = { InvestmentName: ele.InstrumentName, FinexDocumentUrl: ele.FinexDocumentUrl };
            row["TotalValue"] = ele.TotalValue.toFixed(2).toString() + "%";
            header.forEach((col) => {
                const value = ele.AssetSectorAllocations.filter((item) => item.SectorName == col.SectorName)[0];
                row["SecurityType"] = ele.SecurityType;
                row[col.SectorName] = value && value.Value != 0 ? value.Value.toFixed(2).toString() + "%" : "-";
            });
            return row;
        });
        let total: ICombineTableConfig[] = [
            { data: `${this.props.isHeadAccount ? "Portfolio" : "Sub-account"} Total`, tfTdCssWrapper: "cell-right" },
        ];
        total = total.concat(
            header.map((row) => {
                return { data: row.Value.toFixed(2) + "%", tfTdCssWrapper: "cell-right" };
            })
        );
        total.push({
            data:
                header
                    .reduce((total, current) => {
                        return total + current.Value;
                    }, 0)
                    .toFixed(2) + "%",
            tfTdCssWrapper: "cell-right",
        });
        return (
            <div>
                <Table col={tableConfig} data={content} TotalBody={total} cssWrapper="is-compact" />
            </div>
        );
    }
}
